<template>
	<div id="subscriptionModalComponent">
		<button class="btn-link" data-toggle="modal" data-target=".subscription-modal" ref="newSusbcription" v-show="false" @click="initComponentLocal">Nueva Suscripción</button>
		<button ref="getSusbcription" @click="showSubscriptionLocal" v-show="false">Buscar Suscripcion</button>

		<div class="modal fade subscription-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" v-if="idLocal == 0">Nueva Suscripción {{ subscriptionId }}</h5>
						<h5 class="modal-title" v-else>Suscripción Nº {{ idLocal }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body row">
						<div class="col-8">
							<div v-show="!searching">
								<div v-show="listProductsSubscription.length > 0">
									<nav class="navbar navbar-light bg-light">
										<div class="form-inline">
											<select	v-model="priceListId" class="form-control form-control-sm" @change="getProductSubscriptionByYear()">
												<option v-for="(item, index) in listPriceLists" :key="index" :value="item.id">{{ item.name }}</option>
											</select>
										</div>
										<div class="form-inline">
											<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Código" aria-label="Buscar" ref="inputSearchProduct"
												v-show="!showAllProduct"
												v-model="inputSearchProduct"
												v-on:keyup.enter="searchProduct"
												onfocus="this.select()">
											<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="searchProduct" v-show="!showAllProduct">Buscar</button>
										</div>
										<div class="form-inline">
											<div class="form-check">
												<input class="form-check-input" type="checkbox" value="" id="defaultCheck1"
													v-model="showAllProduct"
													@change="changeShowAllProduct"
													:disabled="listProductsSubscription.length == 0">
												<label class="form-check-label" for="defaultCheck1">
													Mostrar todos los Productos
												</label>
											</div>								
										</div>
									</nav>

									<table class="table-subscription table-striped table-hover">
										<thead>
											<tr>
												<th class="text-center" style="width: 75px">ID</th>
												<th class="text-center">Producto</th>
												<th class="text-center">Precio</th>
												<th class="text-center">Cantidad</th>
												<th class="text-center" style="width: 75px">
													Total
												</th>
												<th class="text-center">
													<i class="fas fa-broom float-right" @click="clearListProductsSubscription"></i>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in listProductsSubscription" :key="index"
												v-show="(listProductsSubscriptionIndex==index || item.quantity > 0 || showAllProduct) && productPrice(item) > 0">
												<td class="text-center">{{ item.product_id }}</td>
												<td>{{ item.product }}</td>
												<td class="td text-right"><b>{{ methodFormatNumber(productPrice(item)) }}</b></td>
												<td class="text-right">
													<input class="text-right input-quantity" type="text" min="0" v-model="item.quantity"
															:ref="'quantity' + index"
															onfocus="this.select()"
															@keyup.enter="keyupEnter(index)"
															@keyup.down="keyupEnter(index)"
															@keyup.up="keyupUp(index)"
															@focus="focus(index)"
															@blur="eventBlour(item)"
															:disabled="id > 0"/>
												</td>
												<td class="text-right">{{ methodFormatNumber(productPrice(item) *  Math.trunc(Math.abs(item.quantity))) }}</td>
												<td class="text-center">
													<i class="fas fa-exclamation-triangle text-warning" v-show="item.quantity != 0 && methodFormatNumber(productPrice(item) *  Math.trunc(Math.abs(item.quantity))) == 0"></i>
													<i class="fas fa-check text-success" v-show="item.quantity != 0 && methodFormatNumber(productPrice(item) *  Math.trunc(Math.abs(item.quantity))) > 0"></i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="alert alert-info" role="alert" v-show="!searching && listProductsSubscription.length == 0">
									No se encontraron productos para el periodo {{ subscriptionId }}
								</div>							
							</div>
							<div v-show="searching">
								<div class="alert alert-info" role="alert">
									<i class="spinner-border spinner-border-sm"></i> Buscando Pruductos . . .
								</div>
							</div>
						</div>
						<div class="col-4">
							<div class="alert alert-secondary" role="alert">
								<h4>
									TOTAL: <span class="float-right">{{ methodFormatNumber(totalSuscripcionProducts) }}</span>
								</h4>
							</div>
							<div>
								<div class="form-group">
									<label for="inputChurch">Iglesia</label>
									<churchs-input-component ref="churchsInputComponent"
										:url="url"
										@actionSelectItem="setChurchLocal"></churchs-input-component>
								</div>
								<div class="form-group">
									<label for="inputClient">Cliente</label>
									<autocomplete-input-component
										_class="form-control form-control-sm"
										:_path="apiBackend + 'clients'"
										@actionSelectItem="setClientLocal"></autocomplete-input-component>
								</div>
							</div>
							<hr>
							<div>
								<div class="form-check">
									<button type="button" class="btn btn-sm btn-primary float-right" :disabled="disableBtnSave" @click="saveSubscriptionLocal">Guardar</button>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" ref="closeSusbcription">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import priceList from '@/mixins/generals/priceList.js'

	import ChurchsInputComponent from '@/components/ChurchsInputComponent.vue'
	import AutoCompleteInputComponent from '@/components/AutoCompleteInputComponent.vue'
	
	export default {
		name: 'SubscriptionModalComponent',
		mixins: [axiosAction, errors, mixin, priceList],
		props: ['subscriptionId', 'defaultPriceListId', 'id', 'url'],
		data () {
			return {
				listProductsSubscription: [],
				listProductsSubscriptionIndex: -1,
				showAllProduct: true,
				inputSearchProduct: '',
				lastFocusInputSearchProduct: false,
				searching: false,
				clientId: 0,
				churchId: 0,
				closeWindow: true,
				objectClientSendto: {
					id: 0,
					sendto: '',
					phone: '',
					number_document: '',
					email: '',
					created_at: '',
					updated_at: ''
				},
				subscriptionIdLast: 0,
				priceListId: 0
			}
		},
		computed: {
			disableBtnSave() {
				if(this.totalSuscripcionProducts == 0 || isNaN(this.totalSuscripcionProducts))
					return true
				if(this.listProductsSubscriptionSelect.length == 0)
					return true
				if(this.clientId == 0)
					return true
				if(this.churchId == 0)
					return true
				return false
			},
			idLocal() {
				if(this.id == 0) {
					this.clearModal()
				}
				return this.id
			},
			listProductsSubscriptionSelect() {
                let list = this.listProductsSubscription.filter(p => Math.trunc(Math.abs(p.quantity)) > 0)
                return list
            },
            totalSuscripcionProducts() {
                let total = this.listProductsSubscription.reduce((a, b) => { 
                                let c = Math.trunc(Math.abs(b.quantity)) * this.productPrice(b)
                                return a + c
                            }, 0);
                return total.toFixed(0)
            },
		},
		methods: {
			initComponentLocal() {
				this.priceListId = this.defaultPriceListId
				this.clearModal()
				this.getAllPriceListsLocal()
				this.$refs.churchsInputComponent.$refs.getChurchs.click()
				this.$refs.churchsInputComponent.$refs.clear.click()
			},
			actionSelectItemClient(data) {
				console.log(data)
			},
			clearListProductsSubscription() {
				Object.keys(this.listProductsSubscription).forEach(index => {
					this.listProductsSubscription[index].quantity = 0
				});
			},
			clearModal() {
				this.listProductsSubscriptionIndex = -1
				this.clearListProductsSubscription()
				this.inputSearchProduct = ''
			},
			changeShowAllProduct() {
				this.lastFocusInputSearchProduct = false
				this.clearModal()
				setTimeout(() => {
					if(!this.showAllProduct) {
						this.$refs.inputSearchProduct.focus()
					} else {
						this.listProductsSubscriptionIndex = 0
						this.focusInput(this.listProductsSubscriptionIndex)
					}
				}, 10)
			},
            eventBlour(item) {
                if(item.quantity == '')
                    item.quantity = 0
                item.quantity = Math.trunc(Math.abs(item.quantity))
            },
			getAllPriceListsLocal() {
				this.getAllPriceLists()
			},
			getAllPriceListsResultLocal(response) {
				if(response.data.success == true) {
					this.getProductSubscriptionByYear()
				}
			},
			getProductSubscriptionByYear() {
				console.log(this.defaultPriceListId)
				if(this.listProductsSubscription.length == 0 || this.subscriptionIdLast != this.subscriptionId) {
					this.subscriptionIdLast == this.subscriptionId
					this.searching = !this.searching
					this.axiosActionIS(this.url + 'products/subscription/' + this.subscriptionId + '/priceList/' + this.priceListId, 'GET', 'getProductSubscriptionByYearResult', null)
				}
			},
			getProductSubscriptionByYearResult(response) {
				this.searching = !this.searching
				if(response.data.success === true) {
					this.listProductsSubscription = response.data.data
				}
			},
			saveSubscriptionLocal() {
                let data = {
                        client_id: this.clientId,
                        church_id: this.churchId,
						client_sendto: this.objectClientSendto,
                        subscription_id: this.subscriptionId,
                        products: this.listProductsSubscriptionSelect,
						frontend: 'isystem4'
                    }
				if(!this.disableBtnSave) {
					let url = this.apiBackend + 'order/subscription/register'
					this.axiosActionIS(url, 'POST', 'saveSubscriptionLocalResult', data)
				} else {
					alert('Faltan datos por Completar')
				}
			},
			saveSubscriptionLocalResult(response) {
				if(response.data.success === true) {
					this.$emit('actionSaveSubscription', response.data.data)
					if(this.closeWindow) {
						this.$refs.closeSusbcription.click()
					}
					this.clearModal()
				} else {
					alert('La respuesta no era lo que se esperaba')
					console.log(reponse.data)
				}
			},
			showSubscriptionLocal() {
				if(this.idLocal > 0) {
					console.log('Buscando Suscripcion Nº ' + this.id)
				}
			},
			keyupEnter (index) {
				index = (index < this.listProductsSubscription.length-1) ? index+1 : 0
				this.focusInput(index)
			},
			keyupUp (index) {
				index = (index == 0) ? this.listProductsSubscription.length - 1 : index - 1
				this.focusInput(index)
			},
			focus(index) {
				this.listProductsSubscriptionIndex = index
			},
			focusInput(index, lastFocus = false) {
				if(lastFocus || (!lastFocus && !this.lastFocusInputSearchProduct)) {
					this.lastFocusInputSearchProduct = (lastFocus) ? lastFocus : this.lastFocusInputSearchProduct
					this.listProductsSubscriptionIndex = index
					setTimeout(() => {
						this.$refs['quantity'+index][0].focus()
					}, 10);
				} else {
					this.listProductsSubscriptionIndex = -1
					this.$refs.inputSearchProduct.focus()
				}
			},
            productPrice(item) {
                let total = item.subscription_product.reduce(function(a, b) {
                                    let c = (b.status_id == 1) ? parseInt(b.price) : 0
                                return a + c
                            }, 0);
                return parseInt(total)
            },
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getAllPriceListsResult': this.getAllPriceListsResult(response); break;
					case 'getProductSubscriptionByYearResult': this.getProductSubscriptionByYearResult(response); break;
					case 'saveSubscriptionLocalResult': this.saveSubscriptionLocalResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			searchProduct() {
				let index = this.listProductsSubscription.map((el) => parseInt(el.product_id)).indexOf(parseInt(this.inputSearchProduct))
				if(index > -1) {
					this.inputSearchProduct = ''
					this.focusInput(index, true)
				} else {
					alert('Producto no encontrado')
				}

			},
			setChurchLocal(item) {
				this.churchId = item.id
			},
			setClientLocal(item) {
				if(item.item.client_sendto == null) {
					this.objectClientSendto.id = -1
					this.objectClientSendto.sendto = (item.item.name + ' ' + item.item.surname).trim()
					this.objectClientSendto.phone = item.item.phone
					this.objectClientSendto.number_document = item.item.number_document
					this.objectClientSendto.email = item.item.email
					this.objectClientSendto.created_at = ''
					this.objectClientSendto.updated_at = ''
				} else {
					this.objectClientSendto.id = item.item.client_sendto.id
					this.objectClientSendto.sendto = item.item.client_sendto.sendto
					this.objectClientSendto.phone = item.item.client_sendto.phone
					this.objectClientSendto.number_document = item.item.client_sendto.number_document
					this.objectClientSendto.email = item.item.client_sendto.email
					this.objectClientSendto.created_at = item.item.client_sendto.created_at
					this.objectClientSendto.updated_at = item.item.client_sendto.updated_at					
				}
				this.clientId = item.id
			}
		},
		components: {
			'churchs-input-component': ChurchsInputComponent,
			'autocomplete-input-component': AutoCompleteInputComponent,
		},
		mounted () {
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.table-subscription {
		width: 100%;
	}
	.input-quantity {
		border: none;
		width: 100%;
		max-width: 75px;
		background-color: transparent;
	}
</style>
